'use client'

import { useEffect, useRef } from 'react'
import { useTracking } from '@/app/contexts/tracking-context'
import { HealthTrackingEnum } from '@/app/enums/HealthTrackingEnum'

// Funnel entry — fires on the /devis-mutuelle-sante landing page only, so a token URL reopened later isn't a new entry.
export default function HealthFunnelAccessTracker() {
    const { track } = useTracking()
    const firedRef = useRef(false)

    useEffect(() => {
        if (firedRef.current) return
        firedRef.current = true
        track({ event: HealthTrackingEnum.FunnelAccess })
    }, [track])

    return null
}
